import { createFileRoute } from "@tanstack/react-router";
import { GraduationCap } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { Review } from "@/features/research/modules/review/review";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/review/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.research_review_title() }),
});

function RouteComponent() {
  return (
    <PageShell icon={GraduationCap} title={m.research_review_title()} description={m.research_review_description()}>
      <Review />
    </PageShell>
  );
}
